<template>
    <div class="content-wrapper">
        <div class="container-lg">
            <div class="row">
                <div class="col">
                    <app-navbar/>
                </div>
            </div>
            <div class="row mb-12">
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <div class="content-card mb-4">
                                <app-mainGame />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="push"></div>
        </div>
    </div>
</template>
<script>
import mainGame from '@/components/sakha/game/mainGame'
import navbar from '@/components/sakha/game/navbar'
export default {
  components: {
    'app-mainGame': mainGame,
    'app-navbar': navbar
  },
  data: () => {
    return {
      selectDate: '',
      showOverlay: true,
      lotteryInformation: null
    }
  },
  async created () {

  },
  methods: {

  },
  computed: {

  },
  watch: {
    selectDate: function (val) {
      this.showOverlay = true
      this.getLottoResultAll(val)
    },
    getLottoResultAllList: function (val) {
      if (this.showOverlay === true) {
        this.showOverlay = false
      }
    }
  }
}
</script>
